class PlantArtGallery {
  constructor(root) {
    this.root = root;
    this.panels = Array.from(root.querySelectorAll('[data-gallery-panel]'));
    this.thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    this.counter = root.querySelector('[data-gallery-counter]');
    this.index = 0;

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.show(index));
    });

    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));
  }

  show(index) {
    if (!this.panels.length) return;
    this.index = (index + this.panels.length) % this.panels.length;
    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== this.index;
    });
    this.thumbs.forEach((thumb, thumbIndex) => {
      thumb.setAttribute('aria-selected', thumbIndex === this.index ? 'true' : 'false');
    });
    if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.panels.length}`;
  }
}

document.querySelectorAll('[data-pag-gallery]').forEach((gallery) => new PlantArtGallery(gallery));
